import request from "request";

class ScienceControl {
  addControl() {
    const containerId = 'layers-controls';
    this._container = document.getElementById(containerId) || document.createElement('div');
    this._container.id = containerId;

    this._el = document.createElement('button');
    this._el.className = 'science-icon';
    this._el.dataset.layoutPropertyIds = 'science';
    this._el.title = 'Science';
    this._container.appendChild(this._el);
    this._el.addEventListener('click', this.onClick.bind(this));
    return this._container;
  }

  addScienceLayer() {
    request('https://ar2.zerosixzero.org/api/science_posts/exxpedition2019', (error, response, body) => {
      if (error) console.error('API Error: ', error);
      const posts = JSON.parse(body || {});

      posts.forEach(({ geometry, properties }) => {
        let size;
        switch (properties.data) {
          default:
          case '<50':
            size = 'small';
            break;
          case '50-99':
            size = 'medium';
            break;
          case 'pending':
          case 'unknown':
            size = 'hidden';
            break;
        }

        // create a HTML element for each post
        const el = document.createElement('div');
        el.className = `marker science control-layer ${properties.type} ${size}`;
        el.style.display = 'none';

        let html = `<div class="location">${properties.type} Trawl</div>
                      <div>Date: ${properties.date}</div>`;
        if (properties.data_label) {
          html += `<div class="data_label">${properties.data_label}: ${properties.data}</div>`;
        }

        const popup = new mapboxgl.Popup(
            {
              anchor: 'bottom',
              offset: 18/4,
            }
          )
          .setHTML(html);

        // make a marker for each post and add to the map
        new mapboxgl.Marker(el)
          .setLngLat(geometry.coordinates)
          .setPopup(popup)
          .addTo(map);
      });
    });
  }

  onAdd(map) {
    this._map = map;
    this.addScienceLayer();
    return this.addControl();
  }

  onClick() {
    // Get all custom layout property IDs from each button dataset
    // Deactivate all other custom layers
    const customLayoutPropertyIds = Array.from(this._container.children)
      .forEach(el => {
        el.classList.remove('active');
        el.dataset.layoutPropertyIds.split(' ').forEach(id => {
          if (id !== 'science') {
            this._map.setLayoutProperty(id, 'visibility', 'none');
          }
        });
      });

    const posts = Array.from(document.querySelectorAll('.science:not(.hidden)'));
    const postsVisible = posts[0].style.display === 'block';
    this._el.classList.toggle('active', !postsVisible);
    posts.forEach(post => post.style.display = postsVisible ? 'none' : 'block');
  }

  onRemove() {
    this._container.removeChild(this._el);
    this._el = undefined;
    this._map = undefined;
  }
}

export default ScienceControl;
